import { loadDGsForAgents } from "app/components/flow/designer/agents-loader";
import { getDatabaseType } from "app/components/common/editor/control/connection-text-field/connection-test-view";
import dateLib from "core/utils/date-utils";
import { timezone } from "../../../core/utils/date-utils";

const getFormValueCaseInsensitive = (values, key) => {
    if (!values || !key) return undefined;
    if (values[key] !== undefined) return values[key];
    const lowerKey = key.toLowerCase();
    const match = Object.keys(values).find(k => k.toLowerCase() === lowerKey);
    return match ? values[match] : undefined;
};

export const getValidationDetails = ({ propertiesModel, handler, formRef, apiParams, isApplicationHelperAPI }) => {
    const validationDtls = {};
    Object.values(apiParams).forEach(key => {
        const userInput = getFormValueCaseInsensitive(formRef?.current?.values, key);
        if (isApplicationHelperAPI) {
            validationDtls[key] = typeof userInput === "object" ? userInput?.value : userInput;
        } else {
            // Send Passwords as object to executePropertyActions
            if (userInput !== null && typeof userInput === "object" && !userInput.encrypted)
                validationDtls[key] = userInput?.value;
            else validationDtls[key] = userInput;
        }
    });

    const agentDeploymentGroups = loadDGsForAgents();

    let caseInsensitiveModel = {};
    Object.keys(propertiesModel).forEach(propertyName => {
        caseInsensitiveModel[propertyName.toLowerCase()] = propertiesModel[propertyName];
    });

    validationDtls.adapterName = getAdapterName(caseInsensitiveModel?.adaptername, handler);

    if (isApplicationHelperAPI) {
        if (Object.values(apiParams).includes("Password")) {
            if (formRef?.current?.touched?.Password) {
                validationDtls.encrypted = false;
            } else {
                validationDtls.Password =
                    getPassword(caseInsensitiveModel?.password) || getPassword(validationDtls.Password);
                validationDtls.encrypted = !!caseInsensitiveModel.password_encrypted;
            }
        }
    }
   

    validationDtls.databaseProviderType = caseInsensitiveModel["databaseprovidertype"];
    validationDtls.agentDeploymentGroups = agentDeploymentGroups
        ? agentDeploymentGroups.map(group => ({
              label: group.get("name"),
              value: group.get("id")
          }))
        : null;
    validationDtls.databaseType = getDatabaseType(validationDtls.adapterName, caseInsensitiveModel["databaseprovidertype"]);

    return validationDtls;
};

const getAdapterName = (adapterName, resourceNamespace) => {
    if (adapterName) {
        return adapterName;
    }

    // for new components the adaptername is not provided
    // we parse this from resourceNamespace which contains adapter name
    if (!resourceNamespace) {
        return null;
    }
    let nameParts = resourceNamespace.split(".");
    if (nameParts.length !== 3) {
        return null;
    }
    return nameParts[2];
};

const getPassword = password => {
    if (password && password.encrypted) {
        return password.encrypted;
    }
    return password;
};

export const getDateTime = () => {
    const date = dateLib();
    return `${date.format("ll")} at ${date.format("h:mm A")} ${timezone}`;
};
